// extracted by mini-css-extract-plugin
module.exports = {"blank":"blank_blank__10ksS","content":"blank_content__3pQrx","blank_ctrl":"blank_blank_ctrl__1OVIu"};